module.exports = __webpack_public_path__ + "static/media/icn-download-report.ba90664a.svg";